import React from 'react';
import { useTable } from 'react-table';
import { ProductName, TableData, ProductItem } from './styles';
import { DataItem } from '../../interfaces/TimeReportInterface';

interface MainColumns {
  Header: string;
  accessor: string;
}

interface TableComponentProps {
  columns: MainColumns[];
  data: DataItem[];
}

const TableSubRow: React.FC<TableComponentProps> = ({ columns, data }) => {
  const { rows, prepareRow } = useTable({ columns, data });

  return (
    /* eslint-disable react/jsx-props-no-spreading */
    <>
      {rows.map((row) => {
        prepareRow(row);
        return (
          <React.Fragment key={row?.id}>
            <tr {...row.getRowProps()} key={row?.id}>
              {row.cells.map((cell, cellIndex) => (
                <TableData {...cell.getCellProps()} key={cell.column.id}>
                  {cellIndex === 0 ? (
                    <ProductItem>
                      <div className='plus-icon'></div>
                      <ProductName>
                        <p>{String(cell.row.original[columns[0].accessor])}</p>
                      </ProductName>
                    </ProductItem>
                  ) : (
                    cell.render('Cell')
                  )}
                </TableData>
              ))}
            </tr>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default TableSubRow;
